import useSWR from 'swr';
import useSdk from 'helpers/hooks/useSdk';
import { revalidateOptions } from 'frontastic';
import { Store } from './types';

type Params = { productId?: string };

const useStores = ({ productId = '' }: Params = {}) => {
  const sdk = useSdk();
  const result = useSWR(
    `/action/yggdrasil/getStores?productId=${productId}`,
    () => {
      return sdk.callAction<Store[]>({
        actionName: 'yggdrasil/getStores',
        query: { productId },
      });
    },
    revalidateOptions,
  );

  const stores = result.data?.isError ? undefined : result.data?.data;

  return {
    stores,
  };
};

export default useStores;
